import * as actionTypes from "../actionTypes";

const initialState = {
  ipiData: null,
  ipiLoaded: false,
};

const IPI = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_IMPORTANT_PLAN_INFO_SUCCESS:
      return {
        ...state,
        ipiData: action.response,
        ipiLoaded: true,
      };
    default:
      return state;
  }
};

export default IPI;
